/* global CUSTOMER_API_URL */

import { createFetch, createFirebase } from 'next/lib/fetch';

/**
 * Create an authenticated API client
 *
 * @param {object} auth - Auth information
 * @param {string} auth.accountId - Account ID
 * @param {string} auth.jwt - Account JWT
 * @param {string} auth.token - Firebase ID token
 * @return {function} Authenticated API client
 */
export function createApiClient(auth = {}) {
  const customerAPI = createFetch(`${CUSTOMER_API_URL}/v1`, auth);
  const firebaseAPI = createFirebase(auth);

  return {
    /**
     * Customer API
     */
    getFlows: () => customerAPI('flows?summary=true'),

    /**
     * Firebase endpoints
     */
    getAccount: () => firebaseAPI('meta'),

    getUser: id => firebaseAPI(`users/${id}/meta`, { account: false }),
  };
}
